let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("421Eq")).then(() => parcelRequire('8XVSm'));